import React from 'react';

const InfoPage = () => {
    return (
        <div className="bg-white rounded-lg shadow-md p-6">
            {/* Header Section */}
            <h1 className="text-4xl font-bold text-gray-900 mb-6">About Us</h1>

            {/* About Us Section */}
            <div className="mb-6">
                <h2 className="text-2xl font-semibold text-gray-800 mb-3">Luka Healthcare</h2>
                <p className="text-base text-gray-600 leading-relaxed">
                    Luka Healthcare is dedicated to understanding the challenges faced by patients and caregivers. 
                    Healthcare is transforming with patient and caregiver experience at the heart of everything. 
                    Our focus is on creating innovative healthcare solutions that address the goals, initiatives, 
                    and actions that enhance these experiences.
                </p>
                <p className="text-base text-gray-600 leading-relaxed mt-3">
                    We are a team of professionals working closely with caregivers and patients. 
                    Through our research and studies, we strive to improve healthcare solutions 
                    that make a meaningful impact.
                </p>
            </div>

            {/* Contact Information Section */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Address */}
                <div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">Address</h3>
                    <p className="text-lg text-gray-600">
                        Luka Healthcare Pvt. Ltd.<br />
                        Office No. 123, VASURA INN,<br />
                        Near SA College, Edathua PO,<br />
                        Pin: 689573, Alappuzha,<br />
                        Kerala, INDIA
                    </p>
                </div>

                {/* Let's Talk & Email */}
                <div>
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">Contact Us</h3>
                    <div className="mb-3">
                        <p className="text-lg text-gray-600 font-medium">Let's Talk:</p>
                        <p className="text-lg text-gray-600">0091 88488 51134</p>
                        <p className="text-lg text-gray-600">+91 88488 51134</p>
                    </div>
                    <div>
                        <p className="text-lg text-gray-600 font-medium">E-mail Us:</p>
                        <p className="text-lg text-gray-600">
                            <a href="mailto:info@lukahealthcare.com" className="text-blue-600 hover:underline">
                                info@lukahealthcare.com
                            </a>
                        </p>
                        <p className="text-lg text-gray-600">
                            <a href="mailto:sales@lukahealthcare.com" className="text-blue-600 hover:underline">
                                sales@lukahealthcare.com
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InfoPage;